import { REMOVE_WIDGET_ID, RESET_WIDGET_IDS, UNIMPORT_WIDGET_ID, UpdatedWidgetID } from "./types";

interface WidgetIdState {
    datas: string[];
    productId: string[]
}

const initialWidgetIdState: WidgetIdState = {
    datas: [],
    productId: []
};

export function widgetIdReducer(
    state: WidgetIdState = initialWidgetIdState,
    action: UpdatedWidgetID
): WidgetIdState {
    switch (action.type) {
        case UNIMPORT_WIDGET_ID:
            if (!state.datas.includes(action.data)) {
                const updatedDatas = [...state.datas, action.data];
                return { ...state, datas: updatedDatas };
            }
            return state;
        case RESET_WIDGET_IDS:
            return initialWidgetIdState;
        case REMOVE_WIDGET_ID:
            return {
                ...state,
                datas: state.datas.filter(id => id !== action.data)
            };
        default:
            return state;
    }
}
